import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { useNavigate } from "react-router-dom";

const FirstSlick = () => {
  const navigate = useNavigate();

  const moveBottom = () => {
    console.log("눌림");
    const pageHeight = document.documentElement.scrollHeight;

    window.scrollTo({
      top: pageHeight, // 페이지의 높이로 스크롤
      behavior: "smooth",
    });
  };
  const movePage = (path) => {
    navigate(path);
    window.location.reload();
    
  };

  return (
    <div className="first-slide-wrap animate__animated animate__fadeIn">
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
        slidesPerView={1}
        navigation
        scrollbar={{ draggable: true }}
        // autoplay={{ delay: 5000, disableOnInteraction: false }}
      >
        <SwiperSlide className="swiper_slide">
          <div className="slide_image">
            <video
              className="slide_video"
              loop={true}
              autoPlay={true}
              muted={true}
            >
              <source src={"kiwoom_main.mp4"} type="video/mp4"></source>
            </video>
            <div className="banner_text_box">
              <div className="banner_text animate__animated animate__fadeIn">
                키움성장클리닉
              </div>
              <div className="banner_text_sub animate__animated animate__fadeIn">
                아이들의 바른 성장을 위한,
                <br /> 진정성을 담은 최선의 진료를 약속 드립니다.
              </div>
              <button
                className="banner_detail"
                onClick={() => movePage("/intro")}
              >
                자세히 알아보기
              </button>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      
    </div>
  );
};

export default FirstSlick;
